import React from 'react';

import MarkerFilledIcon from '@mui/icons-material/FiberManualRecord';
import MarkerOutlinedIcon from '@mui/icons-material/FiberManualRecordOutlined';
import { SvgIcon } from '@mui/material';

import { StyleIconButton } from './style';

export type MarkerButtonProps = {
  displayed?: boolean;
  displayPosition: number;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const MarkerButton = ({ displayed, displayPosition, onClick }: MarkerButtonProps) => (
  <>
    {displayPosition !== -1 && (
      <StyleIconButton
        size="small"
        disableFocusRipple
        disableRipple
        disableTouchRipple
        onClick={onClick}
        displayPosition={displayPosition}
      >
        <SvgIcon component={displayed ? MarkerFilledIcon : MarkerOutlinedIcon} sx={{ fontSize: '0.75em' }} />
      </StyleIconButton>
    )}
  </>
);

export default MarkerButton;
